<div class="modal" id="otp-verification-modal" tabindex="-1" aria-label="modal" role="dialog" aria-hidden="false" [ngStyle]="{'display': showOTPVerificationPopUp ? 'block' : 'none','opacity': 1, 'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content login-content">
        @if(differentTitleRequired){
            <div class="modal-header border-0">
                @if(otpVerificationModuleType == "icloud"){
                    <div class="icloud-2factor-auth-cont">
                        <p class="main-heading">Two Factor Authentication</p>
                        <p class="sub-text">Please enter the verification code received on your Apple device to continue.</p>
                        <p><b>Note:</b> If you don't have two-factor authentication (2FA) enabled for your Apple ID, please enable 2FA and try again.</p>
                    </div>
                }
                <div class="enter-otp-close-btn-cont" (click)="closeOTPPopup()">
                    <span class="NeueExit-Folder"></span>
                </div>
            </div>
        }
        <div class="modal-body pb-3" [ngClass]="differentTitleRequired ? 'custom-heading' : '' "> 
            @if(!differentTitleRequired){
                <!-- <div class="login-logo top-space">
                    <img src="https://static.jiocloud.com/emailtamplateresources/jiocloud-logo-1.png" alt="Jio Logo" style="width: 52px; height: 52px;" />
                </div> -->
                <div class="login-logo top-space">
                    <h2>
                        OTP verification
                        <p>Enter the OTP sent to you on </p>
                        <p class="entered-email-mobile-number"><span>{{sentSource}}</span></p>
                    </h2>
                    <div class="enter-otp-close-btn-cont" (click)="closeOTPPopup()">
                        <span class="NeueExit-Folder"></span>
                    </div>
                </div>
            }
            <div class="login-form otp-login-main">
                <form onsubmit="return false">
                    <div class="otpVerification">
                        <div id="otp" class="OTPKeypad">
                            <span><input id="digits1" oninput="this.value = this.value.replace(/[^0-9]/g, '')" type="text" class="enterOtp" data-next="digits2" maxlength="1"
                            inputmode="numeric" (keydown)="implRef.moveToNextElement($event, 'digits2')" (keyup)="validateOTP('digits1','digits2',$event)" (paste)="onPasteOtp($event)" name="otpdigits[]" autocomplete="off" /></span>
                            <span><input id="digits2" oninput="this.value = this.value.replace(/[^0-9]/g, '')" type="text" class="enterOtp" data-next="digits3" data-previous="digits1"
                            maxlength="1" inputmode="numeric"  (keydown)="implRef.moveToNextElement($event,'digits3')" (keyup)="validateOTP('digits2','digits3',$event)" (paste)="onPasteOtp($event)"
                            name="otpdigits[]" autocomplete="off" /></span>
                            <span><input id="digits3" oninput="this.value = this.value.replace(/[^0-9]/g, '')" type="text" class="enterOtp" data-next="digits4" data-previous="digits2"
                            maxlength="1" inputmode="numeric" (keydown)="implRef.moveToNextElement($event, 'digits4')" (keyup)="validateOTP('digits3','digits4',$event)" (paste)="onPasteOtp($event)"
                            name="otpdigits[]" autocomplete="off" /></span>
                            <span><input id="digits4" oninput="this.value = this.value.replace(/[^0-9]/g, '')" type="text" class="enterOtp" data-next="digits5" data-previous="digits3"
                            maxlength="1" inputmode="numeric" (keydown)="implRef.moveToNextElement($event, 'digits5')" (keyup)="validateOTP('digits4','digits5',$event)" (paste)="onPasteOtp($event)"
                            name="otpdigits[]" autocomplete="off" /></span>
                            <span><input id="digits5" oninput="this.value = this.value.replace(/[^0-9]/g, '')" type="text" class="enterOtp" data-next="digits6" data-previous="digits4"
                            maxlength="1" inputmode="numeric" (keydown)="implRef.moveToNextElement($event, 'digits6')" (keyup)="validateOTP('digits5','digits6',$event)" (paste)="onPasteOtp($event)"
                            name="otpdigits[]" autocomplete="off" /></span>
                            <span><input id="digits6" oninput="this.value = this.value.replace(/[^0-9]/g, '')" type="text" class="enterOtp" data-previous="digits5" maxlength="1"
                            inputmode="numeric" (keydown)="implRef.moveToNextElement($event)" (keyup)="validateOTP('digits6','null',$event)" (paste)="onPasteOtp($event)" name="otpdigits[]" autocomplete="off" /></span>
                        </div>
        
                        <div class="inputError">
                            @if (this.implRef.isOTPLoginError) {
                                <span><i class="NeueAlert mr-1"></i>{{implRef.exception.errorMessage}}</span>
                            }
                        </div>
                    </div>
                
                
                    @if (showTimer && requestNewOTPCountdown!=0 ){
                        <p class="text-center pt-0 mb-0"><span class="new-otp-timer text-center">Request new OTP in {{requestNewOTPCountdown}} secs</span></p>
                    }
                    @if (!showTimer && requestNewOTPCountdown==0) {
                        <h6 class="opacity-5 cursor-pointer mt-4 txt-resend" (click)="resendOTP()">Resend OTP<span></span></h6>
                    }
                    <button class="btn btn-login f-16 mt-3 ripple-fx" [disabled]="!implRef.enableButton" (click)="verifyOTP()"><span>Continue</span></button>
                </form>
            </div>
        </div>
        <div class="modal-footer border-0 p-0">
          
        </div>
      </div>
    </div>
</div>